import type { Service } from "~/core/ts/entity/Service"
import type { Spa } from "~/core/ts/entity/Spa"
import HeadMetaBuilder from "~/core/ts/util/HeadMetaBuilder"
import { translate } from "~/core/ts/util/translate"

export function getServiceMetadata(spa: Spa, service: Service, url: string): object {
  const serviceName = translate(service.texts).name
  const spaName = spa.name

  const title = `Reserva online ${serviceName} en ${spaName} y al mejor precio en Spalopia`
  const desc = `¿Quieres disfrutar de un ${serviceName} en ${spaName}? Entra en Spalopia y encuentra los mejores servicios de Spa en España ✅`

  const builder = HeadMetaBuilder.create()
    .withTitleAndMetaTitle(title)
    .withMetaDescription(desc)
    .withTwitterMeta(title, desc)
    .withOpenGraphMeta(title, desc)
    .withLink('canonical', url)

  if (service.images.length > 0) {
    const imageUrl = service.images[0].url

    builder
      .withTwitterImage(imageUrl)
      .withOpenGraphImage(imageUrl)
      .withThumbnailImage(imageUrl)
  }

  return builder.get()
}
